import { Component, OnInit } from '@angular/core';
import { PagesContentService } from '../../services/pages-content.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LoginService } from '../../services/frontdoor/login.service';
import { RoleService } from '../../services/frontdoor/role.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-myaccount',
  templateUrl: './myaccount.component.html',
  styleUrls: ['./myaccount.component.scss']
})
/* 
<!-- this component is the perfect sample for multiple editable content areas on one page-->

No matter what is passed from any of the content blocks on the main page which are based 
on the logged in users auth status and role the content will be displayed here.

you can see in the ngOnInit() method that we are subscribing to the authState$ observable

and then subscribing to the role$ observable to determine which content to load.

the loadContent() method is called to load the content from the database based on the role.

the content is sanitized and then displayed on the page.

The page-edit component is where the content is edited and saved to the database. and it's ts file 
determines which content blocks are available for editing. It lists all their names which each have their 
own key in the database.
*/
export class MyaccountComponent implements OnInit {
  isAuthenticated = false;
  content: string = '';
  safeContent: SafeHtml = '';
  errorMessage: string = '';
  roleSubscription: Subscription | undefined;
  role: string | null = null;

  constructor(
    public loginService: LoginService,
    public roleService: RoleService,
    private pagesContentService: PagesContentService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    // Subscribe to the authentication state
    this.loginService.authState$.subscribe(isAuth => {
      this.isAuthenticated = isAuth;
      if (isAuth) {
        // Once authenticated, subscribe to the role to load the proper content key
        this.roleSubscription = this.roleService.role$.subscribe(role => {
          let contentKey = '';
          if (role === 'admin') {
            contentKey = 'accountLandingEditAdmin';
          } else if (role === 'paiduser') {
            contentKey = 'accountLandingEditPaidUser';
          } else if (role === 'user') {
            contentKey = 'accountLandingEditUser';
          }
          // Load content if a key was determined
          if (contentKey) {
            this.loadContent(contentKey);
          }
        });
      }
    });
  }

  loadContent(contentKey: string): void {
    this.pagesContentService.getContent(contentKey).subscribe(
      res => {
        if (res.success && res.data) {
          this.content = res.data.content;
          // Sanitize HTML content to safely bind with innerHTML
          this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.content);
          this.errorMessage = ''; // clear previous errors if any
        } else {
          this.errorMessage = `No content found for ${contentKey}.`;
        }
      },
      error => {
        this.errorMessage = 'Error retrieving content.';
      }
    );
  }
  
  ngOnDestroy(): void {
    if(this.roleSubscription){
      this.roleSubscription.unsubscribe();
    }
  }
}
